enum Roles {
  ROLE_PRESENTER = 'ROLE_PRESENTER',
  ROLE_PARTICIPANT = 'ROLE_PARTICIPANT',
  ROLE_USER = 'ROLE_USER',
  ROLE_UNKNOWN = 'ROLE_UNKNOWN',
}

export default Roles;
